/**
 * Reference:
 * https://qiita.com/H40831/items/5b44ef00cebf532087db
 */
const katakanaToHiragana = (src: string) => {
  return src.replace(/[\u30a1-\u30f6]/g, function (match) {
    const chr = match.charCodeAt(0) - 0x60
    return String.fromCharCode(chr)
  })
}

const hiraganaToKatagana = (src: string) => {
  return src.replace(/[\u3041-\u3096]/g, function (match) {
    const chr = match.charCodeAt(0) + 0x60
    return String.fromCharCode(chr)
  })
}

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&')
}

const generateFuzzyRegExp = (searchWord: string) => {
  searchWord = escapeRegExp(searchWord)
  const chars = searchWord.split('').map((char: string) => {
    const hiragana = katakanaToHiragana(char)
    const katakana = hiraganaToKatagana(char)
    if (hiragana === katakana) return char
    return `(${hiragana}|${katakana})`
  })
  const fuzzyRegExp = new RegExp(`(${chars.join('')})`, 'ig')
  return fuzzyRegExp
}

export const isMatchFuzzy = (searchWord: string, searchedText: string) => {
  const fuzzyRegExp = generateFuzzyRegExp(searchWord)
  return fuzzyRegExp.test(searchedText)
}